/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDocumentWithdraw = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M14.414 2H4v20h8v-2H6V4h7v5h5v4h2V7.586zM15 7V5.414L16.586 7zm.707 11.293L14.414 17H18.5a1.5 1.5 0 0 1 0 3h-2v2h2a3.5 3.5 0 0 0 0-7h-4.086l1.293-1.293-1.414-1.414L10.586 16l3.707 3.707z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDocumentWithdraw as DocumentWithdraw };
